import React from 'react';

const PILLARS = [
  { title: 'Safe & Secure',  desc: 'Only proven, quality-endorsed products and installations.' },
  { title: '24/7 Support',   desc: 'Round-the-clock technical assistance for every client.' },
  { title: 'Reliability',    desc: 'The most suitable solution at the best cost for your needs.' },
  { title: 'GCC Expertise',  desc: 'Deep roots in Qatar and the wider Gulf market since founding.' },
];

const DETAILS = [
  { icon: '📍', text: 'C-Ring Road, Building 76, Doha, Qatar' },
  { icon: '📞', text: '+974 6000 2681 (24/7)' },
  { icon: '🌐', text: 'epo-power.com' },
  { icon: '⚡', text: 'Power · Control · Maintenance divisions' },
  { icon: '🏗️', text: 'Serving military, medical, residential & commercial sectors' },
];

const EpoSection = () => (
  <section className="epo-section" id="about">
    <div className="epo-inner">
      <div className="epo-text">
        <span className="epo-eyebrow">The Company Behind It</span>
        <h2>Reliability Is Our Core Business</h2>
        <p>
          EPO Power and Control Trading is a Doha-based electrical solutions company with expertise
          in power generation, distribution, and building management systems. They are the
          integration partner responsible for deploying Manzili Smart across Siemens
          Desigo Optic-enabled buildings in Qatar and the GCC.
        </p>
        <p>
          With deep expertise in BMS, HVAC controls, and pressure-independent valve systems,
          EPO Power brings the engineering precision required to make smart home automation
          reliable at scale.
        </p>

        <div className="epo-pillars">
          {PILLARS.map(p => (
            <div className="pillar" key={p.title}>
              <span className="pillar-title">{p.title}</span>
              <span className="pillar-desc">{p.desc}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="epo-card">
        <div className="epo-card-header">
          <div className="epo-logo-box">EPO</div>
          <div className="epo-card-name">
            <div className="name">EPO Power & Control Trading</div>
            <div className="sub">Integration Partner · Doha, Qatar</div>
          </div>
        </div>

        <ul className="epo-detail-list">
          {DETAILS.map(d => (
            <li key={d.text}>
              <span className="dl-icon">{d.icon}</span>
              {d.text}
            </li>
          ))}
        </ul>

        <a
          href="https://epo-power.com/"
          target="_blank"
          rel="noopener noreferrer"
          className="epo-link"
        >
          Visit EPO Power
        </a>
      </div>
    </div>
  </section>
);

export default EpoSection;
